/**
 * @description UserProfileWrapper — dashboard content slot for UserProfile.
 *
 * @dependencies
 * - UserProfile: account / security page
 *
 * @notes
 * - Layout padding comes from BaseSidebarLayout; the page sets its own max-width.
 */

import React from 'react';
import UserProfile from './UserProfile';

const UserProfileWrapper = () => {
  return <UserProfile />;
};

export default UserProfileWrapper;
